import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#FBFFFE",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M1 4.733C1 1.933 1.03 1 4.733 1s3.734.933 3.734 3.733.011 3.734-3.734 3.734S1 7.534 1 4.733M12.733 4.733c0-2.8.03-3.733 3.734-3.733 3.703 0 3.733.933 3.733 3.733s.012 3.734-3.733 3.734-3.734-.933-3.734-3.734M1 16.467c0-2.8.03-3.734 3.733-3.734s3.734.933 3.734 3.734c0 2.8.011 3.733-3.734 3.733S1 19.267 1 16.467M12.733 16.467c0-2.8.03-3.734 3.734-3.734 3.703 0 3.733.933 3.733 3.734 0 2.8.012 3.733-3.733 3.733s-3.734-.933-3.734-3.733",
      "clip-rule": "evenodd",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }